import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';


import * as modal from '../../reducers/modalReducer';
import * as menu from '../../reducers/menuReducer';
import SignatureCanvas from 'react-signature-canvas'
import { saveSign } from '../../actions/signup-sync';
import { BODY_TEXT_COLOR } from '../../config/colors';
import { disableScroll } from '../../helpers/scroll';
import { startGetMembership } from '../../actions/signup-sync';

import './style.css'
import { pushWithQueryParams } from '../../services/uri';
const $ = require("jquery");

class MembershipAgreementPage extends Component {

  state = {
    signed: false,
  }
  componentWillMount() {
    const { startGetMembership, tempUser } = this.props;
    if (!tempUser.id) {
      this.props.toMain();
    } else {
      startGetMembership();
    }
  }

  componentDidMount() {
      setTimeout(() => $(window).scrollTop(0), 100);
  }

    onCloseRequest = () => {
        this.props.hideMenu();
        this.props.hideModal();
    }
    styles = {
        hr: {width: '150px', margin: '0 auto', height: 0, borderTop: '1px solid #e6e6e6' },
        labelStyle: {fontWeight:700},
        toggle: {
          maxWidth: 60,
          // marginBottom: 16,
        },
        thumbOff: {
          backgroundColor: '#' + this.props.secondaryColor,
        },
        trackOff: {
          backgroundColor: '#c7d7bc',
        },
        thumbSwitched: {
          backgroundColor: '#' + this.props.secondaryColor,
        },
        trackSwitched: {
          backgroundColor: '#c7d7bc',
        },
        pageTitle: { 
          fontFamily: 'montserrat', 
          fontSize:'28px', 
          color: '#626262', 
          fontWeight:'800', 
          margin:'0 0 0 17px'
        },
        membershipText: {
            fontFamily:'Roboto',
            color: BODY_TEXT_COLOR,
            overflow:'scroll',
            height:'100%',
            padding: '0 25px 0',
            lineHeight: '20px',
            margin: '0 auto',
            maxWidth: '900px'
        },
        signContainer: {
          height: '100px',
          width: '100%',
          margin: '0 auto',
        },
        acceptTermBtn: {
          margin: '20px 0',
          textAlign:'center'
        },
        signHere: {
          textAlign:'center'
        },
        signWrapper: {
          height: '200px'
        }
    };
    handleSignedEnd = () => {
      this.setState({
        signed: true 
      })
    }
    handleAcceptClick = () => {
      const { openWarningPopUp, saveSign, openHowDidYouHear } = this.props;
      // api requset sign up and send auth code
      // save signature to store
      if (!this.state.signed) {
        // show popup
        openWarningPopUp();
        return;
      }
      saveSign(this.sigCanvas.getTrimmedCanvas().toDataURL());
      disableScroll();
      openHowDidYouHear();
    }


    renderProgress = () => {
      if (!this.props.inProgress) return null;
      return <LinearProgress style={{margin: '10px 0'}} color="#8BC027" mode="indeterminate" />
    }

  render() {
    const screenWidth = window.screen.width;
    const canvasWidth = this.props.isPhone ? screenWidth : 325;
    const sigPhone = this.props.isPhone ? 'sigPhone' : '';
    if (!this.props.membershipAgreement) return null;
    const html = {__html: this.props.membershipAgreement};
    return (
         <div style={this.styles.membershipText}>
            {this.renderProgress()}
            <div style={this.styles.membershipText} dangerouslySetInnerHTML={html}></div>
            <div style={this.styles.signWrapper}>
              <div style={this.styles.signContainer}>
                  <SignatureCanvas 
                    ref={(ref) => { this.sigCanvas = ref }} 
                    onEnd={this.handleSignedEnd} 
                    penColor='#616161' 
                    canvasProps={{width: canvasWidth, height: 90, className: `sigCanvas ${sigPhone}`}} 
                    dotSize={2}/>
              </div>
              <div style={this.styles.signHere}>SIGN HERE</div>
            <div style={this.styles.acceptTermBtn}>
              <RaisedButton
                  onClick={this.handleAcceptClick}
                  type="submit"
                  backgroundColor={`#` + this.props.secondaryColor}
                  labelColor="#FFF"
                  label="I Accept These Terms"
                  labelStyle={this.styles.labelStyle}
              />
            </div>
            </div>

        </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    tempUser: state.user.tempUser,
    isPhone: state.config.isPhone,
    membershipAgreement: state.signup.membershipAgreement,
    inProgress: state.upload.inProgress
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      openHowDidYouHear: (props) => dispatch(modal.openModal({
        modalType: 'HOW_DID_YOU_HEAR',
        modalProps: {}
      })), 
      openWarningPopUp: (props) => dispatch(modal.openModal({
        modalType: 'GENERIC',
        modalProps: {
          text: 'Please sign to accept terms and proceed',
          stay: true
        }
      })), 
      hideModal: () => dispatch(modal.hideModal()),
      hideMenu: () => dispatch(menu.menuOff()),
      saveSign: (sign) => dispatch(saveSign(sign)),
      toMain: () => dispatch(pushWithQueryParams('/')),
      startGetMembership: () => dispatch(startGetMembership())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MembershipAgreementPage);


// WEBPACK FOOTER //
// ./src/components/MembershipAgreementPage/MembershipAgreementPage.jsx